import cn from 'classnames'
import * as React from 'react'

import styles from './doodle-background.module.scss'

interface IDoodleBackgroundProps {
  variant?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
}

export default function DoodleBackground({
  className,
  variant = 'topRight',
  ...rest
}: IDoodleBackgroundProps & React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(styles.root, styles[variant], className)} {...rest} />
}
